export default "__VITE_ASSET__BTFHVgGb__"